export default "__VITE_ASSET__CEgel82M__"